/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import types from '../actions/types';
// import { ROLES } from '../config';

const INITIAL_STATE = {
	tools: [],
	toolsByProjectId: []
};

export default function toolsReducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case types.GET_ALL_TOOLS:
			return { ...state, tools: action.payload };
		case types.GET_ALL_TOOLS_BY_PROJECT_ID:
			return { ...state, toolsByProjectId: action.payload };
		default:
			return state;
	}
}

// Selectors
export const getToolsReducer = (state) => {
	return state.tools.tools;
}
export const getToolsByProjectIdReducer = (state) => {
	return state.tools.toolsByProjectId;
}

